import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function AboutPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-319">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-320">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-321">
          <div className="aurora-blob bg-[#FF3CAC] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-322"></div>
          <div className="aurora-blob bg-[#7B2FFF] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-323"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-324">
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-325">
            {t('about.heroTitle')}
            <span className="text-gradient" data-id="element-326">
              {t('about.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 leading-relaxed max-w-3xl mx-auto" data-id="element-327">
            {t('about.heroDesc')}
          </p>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-328">
        <div className="max-w-3xl mx-auto px-6" data-id="element-329">
          <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-330">
            {t('about.originTitle')}
          </h2>
          <div className="prose prose-invert prose-lg max-w-none text-white/70 leading-relaxed" data-id="element-331">
            <p className="mb-6" data-id="element-332">{t('about.originP1')}</p>
            <p className="mb-6" data-id="element-333">{t('about.originP2')}</p>
            <p data-id="element-334">{t('about.originP3')}</p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-335">
        <div className="max-w-7xl mx-auto px-6" data-id="element-336">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-337">
            {t('about.beliefsTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-338">
            {[0, 1, 2].map(idx => <div key={idx} className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 relative overflow-hidden group" data-id="element-339">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-animated opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-340"></div>
                <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-341">
                  {t(`about.belief${idx}Title`)}
                </h3>
                <p className="text-white/60 text-lg leading-relaxed" data-id="element-342">
                  {t(`about.belief${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-343">
        <div className="max-w-7xl mx-auto px-6" data-id="element-344">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-345">
            {t('about.deployedTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-346">
            {[0, 1, 2].map(idx => <div key={idx} className="bg-[#050505] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors flex flex-col h-full" data-id="element-347">
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-348">
                  {t(`about.deployment${idx}Title`)}
                </h3>
                <p className="text-white/60 mb-8 flex-1" data-id="element-349">
                  {t(`about.deployment${idx}Desc`)}
                </p>
                <a href="#" className="inline-flex items-center text-sm font-semibold text-gradient hover:tracking-wide transition-all duration-300" data-id="element-350">
                  {t('about.seeItLive')}{' '}
                  <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-351" />
                </a>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-352">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-353">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-354"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-355"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-356">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-357">
            {t('about.ctaTitle')}
            <span className="text-gradient" data-id="element-358">{t('about.ctaHighlight')}</span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-359">
            {t('about.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}